'use client';
import React from 'react';
import { withDefaultValues } from '../withDefaultValues';
export const HandleLDefaultIcon = withDefaultValues((props: React.SVGProps<SVGSVGElement>) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect x={3} width={3} height={24} rx={1.5} fill="currentColor" /></svg>);